import { Icon } from '@eventbrite/eds-icon';
import { GenericLazyString } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import './Header.scss';
import { LinkedHeaderTitle } from './LinkedHeaderTitle';
import { UnlinkedHeaderTitle } from './UnlinkedHeaderTitle';
import { ViewMore } from './ViewMore';

export interface HeaderProps {
    title?: string | GenericLazyString;
    linkUrl?: string;
    template?: string;
    viewMoreText?: string;
    viewMoreMarkedNoFollow?: boolean;
    iconType?: JSX.Element;
    enableClientSideLinking?: boolean;
}

export const Header: React.FunctionComponent<HeaderProps> = (props) => {
    const {
        title,
        linkUrl,
        template,
        viewMoreText,
        iconType,
        viewMoreMarkedNoFollow,
        enableClientSideLinking,
    } = props;

    if (!title) {
        return null;
    }

    let icon = null;

    if (iconType) {
        icon = (
            <span className="eds-l-pad-left-2 eds-l-pad-bot-1">
                <Icon
                    type={iconType}
                    width="36px"
                    height="36px"
                    color="grey-700"
                />
            </span>
        );
    }

    const headerTitleClasses = classNames(
        'header__title',
        'eds-g-cell',
        'eds-g-cell-9-12',
        'eds-l-pad-bot-2',
        'eds-l-lg-pad-bot-4',
        'eds-l-lw-pad-bot-4',
        'eds-l-ln-pad-bot-4',
    );

    return (
        <div
            className="eds-align--center-vertical eds-l-pad-hor-3"
            data-testid="things-to-do-header"
        >
            <div className={headerTitleClasses}>
                {linkUrl ? (
                    <LinkedHeaderTitle
                        linkUrl={linkUrl}
                        title={title}
                        icon={icon}
                        viewMoreMarkedNoFollow={viewMoreMarkedNoFollow}
                        enableClientSideLinking={enableClientSideLinking}
                    />
                ) : (
                    <UnlinkedHeaderTitle title={title} icon={icon} />
                )}
            </div>
            <ViewMore
                linkUrl={linkUrl}
                template={template || ''}
                title={title}
                text={viewMoreText || ''}
                viewMoreMarkedNoFollow={viewMoreMarkedNoFollow}
                enableClientSideLinking={enableClientSideLinking}
            />
        </div>
    );
};
